import ky from 'ky-universal';
import { isBrowser } from 'browser-or-node';

import { seo } from '../constants/actionTypes';
import { staticHost } from '../../config/api';
import isUndefined from '../utils/type-check/isUndefined';

export function fetchDramaSeoInfo(dramaId) {
  return async (dispatch, getState) => {
    const state = getState();
    if (isBrowser && !isUndefined(state.entities.dramaSeoInfo.byId[dramaId])) {
      return;
    }

    try {
      const res = await ky(`${staticHost}/seo/drama/seo_sd_${dramaId}.json`);
      dispatch({
        type: seo.FETCH_DRAMA_SEO_INFO,
        payload: {
          id: dramaId,
          data: (await res.json()).info,
        },
      });
    } catch {};
  };
}
